export default __webpack_public_path__ + "static/media/smile.79aa1b98.svg";